import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';
import { contactInfo, legalInfo } from '../data/mock';

const BrandColumn = () => (
  <div>
    <Link to="/" className="inline-block mb-6" aria-label="Ometis Patrimoine — Accueil" data-testid="footer-logo">
      <img src="/logo-transparent.png" alt="Ometis Patrimoine" loading="lazy" className="h-28 w-auto" />
    </Link>
    <p className="text-sm leading-relaxed text-white/60">Cabinet de gestion de patrimoine indépendant. Conseil sur-mesure, transparent et aligné avec vos objectifs de vie.</p>
    <div className="mt-6 flex gap-3">
      <a href={contactInfo.linkedin} target="_blank" rel="noreferrer" className="w-9 h-9 border border-white/20 flex items-center justify-center hover:border-[#ff7300] hover:text-[#ff7300] transition-colors" aria-label="LinkedIn"><Linkedin size={16} /></a>
    </div>
  </div>
);

const NavColumn = () => (
  <div>
    <h4 className="font-serif text-xl mb-6 text-white">Navigation</h4>
    <ul className="space-y-3 text-sm">
      <li><Link to="/" className="hover:text-[#ff7300] transition-colors">Accueil</Link></li>
      <li><Link to="/cabinet" className="hover:text-[#ff7300] transition-colors">Le cabinet</Link></li>
      <li><Link to="/services" className="hover:text-[#ff7300] transition-colors">Nos services</Link></li>
      <li><Link to="/actualites" className="hover:text-[#ff7300] transition-colors">Actualités</Link></li>
      <li><Link to="/faq" className="hover:text-[#ff7300] transition-colors">FAQ</Link></li>
      <li><Link to="/nous-rejoindre" className="hover:text-[#ff7300] transition-colors">Nous rejoindre</Link></li>
      <li><Link to="/contact" className="hover:text-[#ff7300] transition-colors">Contact</Link></li>
    </ul>
  </div>
);

const ContactColumn = () => (
  <div>
    <h4 className="font-serif text-xl mb-6 text-white">Contact</h4>
    <ul className="space-y-3 text-sm">
      <li className="flex items-start gap-3"><Mail size={16} className="mt-1 text-[#ff7300]" /><a href={`mailto:${contactInfo.email}`} className="hover:text-white">{contactInfo.email}</a></li>
      <li className="flex items-start gap-3"><Phone size={16} className="mt-1 text-[#ff7300]" /><a href={`tel:${contactInfo.phone.replace(/\s/g,'')}`} className="hover:text-white">{contactInfo.phone}</a></li>
      <li className="flex items-start gap-3"><MapPin size={16} className="mt-1 text-[#ff7300]" /><span><span className="text-white/50">Siège social et adresse de correspondance :</span> {contactInfo.headOffice}</span></li>
      <li className="flex items-start gap-3"><MapPin size={16} className="mt-1 text-[#ff7300]" /><span><span className="text-white/50">Bureau d’accueil :</span> {contactInfo.office}</span></li>
    </ul>
  </div>
);

const RegulatoryColumn = () => (
  <div>
    <h4 className="font-serif text-xl mb-6 text-white">Cadre réglementaire</h4>
    <ul className="space-y-2 text-xs text-white/60">
      <li>{legalInfo.name} — {legalInfo.form}</li>
      <li>Capital social {legalInfo.capital} — RCS {legalInfo.rcs}</li>
      <li>Conseiller en Investissements Financiers (CIF)</li>
      <li>Courtier d’assurance ou de réassurance (COA)</li>
      <li>Courtier en opérations de banque et services de paiement (COBSP)</li>
      <li>Régulé par l’AMF et l’ACPR</li>
      <li>ORIAS n° {legalInfo.orias} — www.orias.fr</li>
      <li>Membre de l’ANACOFI (n° {legalInfo.anacofiId})</li>
      <li className="pt-3"><Link to="/reglementaire" className="text-[#ff7300] hover:text-white transition-colors">Mentions réglementaires →</Link></li>
    </ul>
  </div>
);

const Footer = () => (
  <footer className="bg-[#010c23] text-white/80">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <BrandColumn />
        <NavColumn />
        <ContactColumn />
        <RegulatoryColumn />
      </div>
      <div className="border-t border-white/10 mt-16 pt-8 text-xs text-white/50 leading-relaxed" data-testid="footer-disclaimer">
        Les informations publiées sur ce site ont un caractère général et pédagogique. Elles ne constituent ni un conseil personnalisé, ni une recommandation d’investissement, ni une sollicitation à souscrire. Les investissements peuvent présenter un risque de perte en capital ; les performances passées ne préjugent pas des performances futures ; la fiscalité dépend de la situation de chacun et peut évoluer.
      </div>
      <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
        <p>© {new Date().getFullYear()} Ometis Patrimoine. Tous droits réservés.</p>
        <div className="flex flex-wrap gap-6">
          <Link to="/reglementaire" className="hover:text-white transition-colors">Mentions légales</Link>
          <Link to="/reglementaire#confidentialite" className="hover:text-white transition-colors">Confidentialité</Link>
          <Link to="/reglementaire#cookies" className="hover:text-white transition-colors">Cookies</Link>
          <Link to="/reglementaire#reclamations" className="hover:text-white transition-colors">Réclamations & Médiation</Link>
          <Link to="/reglementaire#cgu" className="hover:text-white transition-colors">CGU</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
